import { InspectionDeliveryRequestInterface } from '../interfaces/inspectionDeliveryRequest';
import { InspectionOrder } from "./inspectionOrder";

export class InspectionDeliveryRequest implements InspectionDeliveryRequestInterface {
    id_inspection_delivery_request?: number;
    fk_id_inspection_order: number | null;
    inspection_order: InspectionOrder
    institution_protocol: string;
    code: string;

    constructor() {
        this.fk_id_inspection_order = null;
        this.inspection_order = new InspectionOrder();
        this.institution_protocol = '';
        this.code = '';
    }
}